import { useQuery } from "@apollo/client";
import { useState, createContext, useContext, useMemo } from "react";
import { CATEGORIES } from "services/apollo/Queries";
import { useAdmin } from "features/admin/AdminContext";

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
    const { user, setUser, all_users, setAll_users } = useAdmin();
    const [loader, setLoader] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const [filterState, setFilterState] = useState(''); // 0, 1, '', 'Admin', 'Member'
    const [searchString, setSearchString] = useState('');
    const [sort, setSort] = useState('asc');
    const [categories, setCategories] = useState([]);

    useQuery(CATEGORIES, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            console.log(36, data);

            if (data?.categories) {
                setCategories(data.categories)
                setLoader(false)
            }
        }
    });

    const filteredUsers = useMemo(() => {
        let data = categories;

        // Filter by search string
        if (searchString) {
            const lower = searchString.toLowerCase();
            data = data.filter(t =>
                t.unit_name.toLowerCase().includes(lower)
            );
        }

        // Sort by unit_name (asc/desc)
        data = [...data].sort((a, b) => {
            const nameA = a.unit_name.toLowerCase();
            const nameB = b.unit_name.toLowerCase();

            return sort === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });

        return data;
    }, [categories, searchString, sort]);

    // const updateTeamData = (participants) => {
    //     console.log('updateTeamData:', participants);
    //     setActiveCategory(prev => ({ ...prev, participants: participants }));
    //     setTeams(prev => [...prev.map(t => t.team_id === activeCategory?.team_id ? { ...t, participants: participants } : t)]);
    // }


    const contextValue = useMemo(() => ({
        loader,
        all_users,
        setAll_users,
        user,
        setUser,
        searchString,
        setSearchString,
        filterState,
        setFilterState,
        activeCategory,
        setActiveCategory,
        categories: filteredUsers,
        setCategories,
        sort,
        setSort,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [loader, all_users, user, searchString, filterState, activeCategory, filteredUsers, sort]);

    return (
        <CategoryContext.Provider value={contextValue}>
            {children}
        </CategoryContext.Provider>
    );
};

export const useCategories = () => {
    const context = useContext(CategoryContext);
    if (!context) {
        throw new Error("useCategories must be used within a CategoryProvider");
    }
    return context;
};